import React from "react";

import style from "./context-card.scss";

export interface ContextCardType {
  title: string;
  description: string;
}

interface ContextCardPropTypes {
  copy: ContextCardType;
  form: "quote" | "application";
  centerCard?: boolean;
}

export const ContextCard: React.FC<ContextCardPropTypes> = ({
  copy,
  centerCard,
}) => {
  return (
    <div className={`context-card-wrapper ${centerCard ? "center" : "right"}`}>
      <style jsx>{style}</style>
      <div className="context-card">
        <h2>{copy.title}</h2>
        <p>{copy.description}</p>
      </div>
    </div>
  );
};
